import * as core from '../../../../../../../core'
import * as engagementCharterComponentKind from '../engagement-charter-component-kind'

export const RESOURCE = {
  payload: {
    description: 'The component is some other kind of source document.',
    enumId: core.dms.models.Enum.Id.from({
      partialId: engagementCharterComponentKind.RESOURCE.payload.partialId,
    }),
    id: 'OTHER',
    name: 'Other',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
